import SignInTest from "./../views/SignInTest";
import { ifNotAuthenticated } from './../../../common/utils/router-guards'
// import Home from './../../landing/views/Home.vue'
import store from "../../../store";
import { REPLACE_AUTH_ACTIVE_COMPONENT, TOGGLE_AUTH_POPUP } from "../store/actions";
import ChangePassword from './../components/ChangePassword'
import sha256 from "sha256";

const Home = () => import('./../../landing/views/Home.vue');
// const store = () => import('../../../store');
// const ChangePassword = () => import('./../components/ChangePassword');

export default [
    {
        path: "/signin",
        name: "SignIn",
        component: SignInTest,
        beforeEnter: ifNotAuthenticated,
    },
    {
        path: "/close",

        beforeEnter: (to, from, next) => {
            try {
                window.opener.HandleGoogleLoginPopup(to.query).then(() => { window.close(); }).catch(() => { window.close(); });
            }
            catch (err) { window.close(); }


        },
    },
    {
        path: "/newPassword/:email/:hashedEmail",
        component: Home,
        beforeEnter: (to, from, next) => {
            const email = to.params.email;
            const hashedEmail = to.params.hashedEmail;


            if (sha256("$TT$" + email) != hashedEmail) {

            } else {
                store.dispatch(TOGGLE_AUTH_POPUP, true)
                store.dispatch(REPLACE_AUTH_ACTIVE_COMPONENT, ChangePassword)
            }

            next()
        },
    }
];
